/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = CheckIn
 *
 * 1 = CheckOut
 */
export enum WorkshopCheckOutFilterType {
  CheckIn = 0,
  CheckOut = 1,
}
